import type { HelpFile } from '../../types/help'
import { ParameterEditorTestIds } from '../../../testids/ParameterEditorTestIds'

export const parameterEditorHelp: HelpFile = {
  docPage: '/docs/reporting/parameters',
  texts: {
    [ParameterEditorTestIds.parameterDefinitionEditor]:
      'Parameters exposed by this report or query — each has a name and value type, and is referenced from the SQL by that name.',
    [ParameterEditorTestIds.paramDefNewName]:
      'Name for the new parameter — letters, digits, and underscores only.',
    [ParameterEditorTestIds.btnAddParameter]: null,
  },
}
